import React, { useEffect, useState, useCallback } from 'react';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';

const VistoriaGestao = () => {
    const [loading, setLoading] = useState(false);
    const [etapa, setEtapa] = useState('LISTA'); // LISTA, NOVO, ANALISE
    const [vistorias, setVistorias] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [lojaSelecionada, setLojaSelecionada] = useState("0");
    const [filtroStatus, setFiltroStatus] = useState("TODAS");

    // Estados para criação e análise
    const [itensNovaVistoria, setItensNovaVistoria] = useState([]);
    const [ponto, setPonto] = useState({ descricao: '', tipo: 'TAREFA', foto: '' });
    const [vistoriaEmAnalise, setVistoriaEmAnalise] = useState(null);
    const [itensAnalise, setItensAnalise] = useState([]);

    const idLojaPadrao = localStorage.getItem("loja");
    const eSupervisor = localStorage.getItem("permiteRegional") === 'S' || localStorage.getItem("diretor") === 'S';

    const carregarVistorias = useCallback(async (codEmp) => {
        setLoading(true);
        try {
            const url = (codEmp === "0" && eSupervisor) ? `/vistoria` : `/vistoria/loja/${codEmp}`;
            const res = await api.get(url);
            setVistorias(res.data || []);
        } catch (err) {
            console.error("Erro ao carregar vistorias:", err);
        } finally { setLoading(false); }
    }, [eSupervisor]);

    useEffect(() => {
        api.get("lojas/localizacao").then(res => {
            setLojas(res.data || []);
            if (eSupervisor) {
                carregarVistorias("0");
            } else {
                setLojaSelecionada(idLojaPadrao);
                carregarVistorias(idLojaPadrao);
            }
        });
    }, []);

    // --- LÓGICA DE ANÁLISE (NOVA: INTEGRADA NA TELA) ---
    const abrirAnalise = async (v) => {
        setLoading(true);
        try {
            const res = await api.get(`/vistoria/${v.id_vistoria}/itens`);
            setVistoriaEmAnalise(v);
            setItensAnalise(res.data || []);
            setEtapa('ANALISE');
        } catch (err) {
            Swal.fire('Erro', 'Não foi possível carregar os detalhes.', 'error');
        } finally { setLoading(false); }
    };

    // --- LÓGICA DE CRIAÇÃO ---
    const handleFotoPonto = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setPonto({ ...ponto, foto: reader.result.split(',')[1] });
            reader.readAsDataURL(file);
        }
    };

    const adicionarItemNaFila = () => {
        if (!ponto.descricao || !ponto.foto) {
            return Swal.fire('Atenção', 'Descrição e foto são obrigatórios.', 'warning');
        }
        setItensNovaVistoria([...itensNovaVistoria, ponto]);
        setPonto({ descricao: '', tipo: 'TAREFA', foto: '' });
        if (document.getElementById('foto-input')) document.getElementById('foto-input').value = "";
    };

    const salvarVistoriaCompleta = async () => {
        if (!lojaSelecionada || lojaSelecionada === "0") return Swal.fire('Erro', 'Selecione uma loja.', 'error');
        setLoading(true);
        try {
            const resVistoria = await api.post('/vistoria', {
                id_loja: lojaSelecionada,
                id_supervisor: localStorage.getItem("chapa"),
                prazo_execucao: new Date(Date.now() + 86400000).toISOString().split('T')[0]
            });
            const idNovo = resVistoria.data.id_vistoria;
            for (const item of itensNovaVistoria) {
                await api.post('/vistoria/item', {
                    id_vistoria: idNovo,
                    descricao: item.descricao,
                    tipo: item.tipo,
                    foto: item.foto
                });
            }
            Swal.fire('Sucesso!', 'Vistoria salva.', 'success');
            setEtapa('LISTA');
            setItensNovaVistoria([]);
            carregarVistorias(eSupervisor ? "0" : lojaSelecionada);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao salvar.', 'error');
        } finally { setLoading(false); }
    };

    const compartilharWhatsApp = (v) => {
        const tokenValido = v.link_token || v.LINK_TOKEN;
        const baseUrl = window.location.origin;

        // FORMATO CORRETO para bater com /:token
        // Remova o "?token=" e coloque apenas a barra
        const link = `${baseUrl}/arbor/Loja/vistoria-execucao/${tokenValido}`;

        const msg = `*VISTORIA #${v.id_vistoria}*\n` +
            `📍 *Loja:* ${v.razao}\n\n` +
            `Acesse para responder:\n${link}`;

        window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
    };

    return (
        <>
            <Menu modulo="ARBOR"/>
            <div className="container mt-4" style={{ paddingTop: '75px', marginBottom: '100px' }}>

                {etapa === 'LISTA' && (
                    <div className="animate__animated animate__fadeIn">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-bold m-0 text-primary">Gestão de Vistorias</h5>
                            {eSupervisor && (
                                <button
                                    className="btn btn-primary rounded-pill px-4"
                                    onClick={() => {

                                        if (
                                            !lojaSelecionada ||
                                            lojaSelecionada === "0"
                                        ) {

                                            return Swal.fire(
                                                'Atenção',
                                                'Selecione uma loja antes de criar a vistoria.',
                                                'warning'
                                            );
                                        }

                                        setEtapa('NOVO');

                                    }}
                                >
                                    + Nova
                                </button>
                            )}
                        </div>

                        <div className="card border-0 shadow-sm mb-4 bg-white p-2 row g-2 mx-0">
                            <div className="col-7">
                                <select className="form-select border-0 bg-light" value={lojaSelecionada} onChange={(e) => { setLojaSelecionada(e.target.value); carregarVistorias(e.target.value); }}>
                                    {eSupervisor && <option value="0">TODAS AS LOJAS</option>}
                                    {lojas.map(l => <option key={l.cod_emp} value={l.cod_emp}>{l.cod_emp} - {l.razao}</option>)}
                                </select>
                            </div>
                            {/*<div className="col-5">
                                <select className="form-select border-0 bg-light" value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
                                    <option value="TODAS">Status</option>
                                    <option value="PENDENTE">Pendentes</option>
                                    <option value="EM_ATRASO">Em Atraso</option>
                                    <option value="FINALIZADA">Finalizadas</option>
                                </select>
                            </div>*/}
                        </div>

                        <div className="row">
                            {vistorias.filter(v => filtroStatus === 'TODAS' || v.status === filtroStatus).map(v => (
                                <div className="col-md-4 mb-3" key={v.id_vistoria}>
                                    <div className="card border-0 shadow-sm h-100">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="badge bg-dark text-white">Loja {v.id_loja}</span>
                                                <span className={`badge ${v.status === 'EM_ATRASO' ? 'bg-danger' : 'bg-success'}`}>{v.status}</span>
                                            </div>
                                            <h6 className="fw-bold mb-1">{v.razao}</h6>
                                            <div className="small text-muted mb-3">Criada: {v.data_inicio} | <span className="text-danger">Prazo: {v.prazo}</span></div>
                                            <div className="d-flex gap-2">
                                                <button className="btn btn-outline-success btn-sm w-100" onClick={() => compartilharWhatsApp(v)}>
                                                    <i className="fab fa-whatsapp"></i> WhatsApp
                                                </button>
                                                <button className="btn btn-light btn-sm w-100" onClick={() => abrirAnalise(v)}>
                                                    Analisar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {etapa === 'NOVO' && (
                    <div className="card shadow-sm p-3 border-0">
                        <h5 className="mb-3 fw-bold">Registrar Item na Vistoria</h5>

                        <div className="mb-3">
                            <label className="small fw-bold">Descrição da Irregularidade / Ponto</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="O que foi observado no setor?"
                                value={ponto.descricao}
                                onChange={e => setPonto({ ...ponto, descricao: e.target.value })}
                            />
                        </div>

                        <div className="row g-2 mb-3">
                            <div className="col-6">
                                <label className="small fw-bold">Tipo de Registro</label>
                                <select className="form-select" value={ponto.tipo} onChange={e => setPonto({ ...ponto, tipo: e.target.value })}>
                                    <option value="TAREFA">GERAR TAREFA</option>
                                    <option value="OBSERVACAO">APENAS OBSERVAÇÃO</option>
                                    <option value="ELOGIO">ELOGIO</option>
                                </select>
                            </div>
                            <div className="col-6">
                                <label className="small fw-bold">Foto (Antes)</label>
                                <input type="file" capture="environment" accept="image/*" className="form-control" onChange={handleFotoPonto} />
                            </div>
                        </div>

                        <button className="btn btn-info w-100 mb-4 fw-bold text-white shadow-sm" onClick={() => {
                            if (!ponto.descricao) return Swal.fire('Aviso', 'Descreva o que foi observado.', 'warning');
                            setItensNovaVistoria([...itensNovaVistoria, ponto]);
                            setPonto({ descricao: '', tipo: 'TAREFA', foto: '' });
                        }}>
                            + Adicionar à Lista
                        </button>

                        {itensNovaVistoria.length > 0 && (
                            <div className="mb-4">
                                <h6 className="small fw-bold text-muted text-uppercase">Itens para envio:</h6>
                                {itensNovaVistoria.map((it, idx) => (
                                    <div key={idx} className="alert alert-light py-2 border mb-2 d-flex justify-content-between align-items-center shadow-sm">
                                        <span className="small"><strong>{it.tipo}:</strong> {it.descricao.substring(0, 40)}...</span>
                                        <button className="btn btn-sm text-danger border-0 bg-transparent" onClick={() => setItensNovaVistoria(itensNovaVistoria.filter((_, i) => i !== idx))}>
                                            Remover
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="d-flex gap-2">
                            <button className="btn btn-outline-secondary w-50 shadow-sm" onClick={() => setEtapa('LISTA')}>Voltar</button>
                            <button className="btn btn-success w-50 fw-bold shadow-sm" onClick={salvarVistoriaCompleta}>Finalizar Tudo</button>
                        </div>
                    </div>
                )}

                {etapa === 'ANALISE' && vistoriaEmAnalise && (
                    <div className="animate__animated animate__fadeIn">
                        <div className="d-flex align-items-center mb-3">
                            <button className="btn btn-light rounded-circle me-3" onClick={() => setEtapa('LISTA')}><i className="fa fa-arrow-left"></i></button>
                            <h5 className="fw-bold m-0 text-primary">Análise: Loja {vistoriaEmAnalise.id_loja}</h5>
                        </div>

                        <div className="row">
                            {itensAnalise.map(item => (
                                <div className="col-12 mb-3" key={item.id_item}>
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <h7 className="text-danger">{item.tipo}</h7>
                                            <h6 className="fw-">{item.descricao_ponto}</h6>
                                            <div className="row g-2">
                                                {/* FOTO ANTES */}
                                                <div className="col-6 text-center">
                                                    <small className="d-block text-muted mb-1">Antes (Supervisor)</small>
                                                    {item.foto_antes && item.foto_antes !== "null" ? (
                                                        <img
                                                            src={`data:image/jpeg;base64,${item.foto_antes}`}
                                                            className="img-fluid rounded shadow-sm border"
                                                            alt="Antes"
                                                            style={{ maxHeight: '150px', objectFit: 'cover', width: '100%' }}
                                                        />
                                                    ) : (
                                                        <div className="bg-light border rounded d-flex align-items-center justify-content-center text-muted" style={{ height: '100px', fontSize: '12px' }}>
                                                            <i className="fa fa-image me-1"></i> Sem Foto
                                                        </div>
                                                    )}
                                                </div>

                                                {/* FOTO DEPOIS */}
                                                <div className="col-6 text-center">
                                                    <small className="d-block text-muted mb-1">Depois (Gerente)</small>
                                                    {item.foto_depois && item.foto_depois !== "null" ? (
                                                        <img
                                                            src={`data:image/jpeg;base64,${item.foto_depois}`}
                                                            className="img-fluid rounded shadow-sm border"
                                                            alt="Depois"
                                                            style={{ maxHeight: '150px', objectFit: 'cover', width: '100%' }}
                                                        />
                                                    ) : (
                                                        <div className="bg-light border rounded d-flex align-items-center justify-content-center text-muted" style={{ height: '100px', fontSize: '12px' }}>
                                                            <i className="fa fa-clock-o me-1"></i> Pendente
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {item.obs_gerente && (
                                                <div className="mt-2 p-2 bg-light border-start border-4 border-success small">
                                                    <strong>Solução do Gerente:</strong> {item.obs_gerente}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>
            {loading && <div className="loader-full"><div className="spinner-border text-primary"></div></div>}
            <Footer />
        </>
    );
};

export default VistoriaGestao;